// Real learner posts (LinkedIn screenshots) used on the homepage testimonials
// marquee and the /alumni-stories page. `home: true` marks the handful shown on
// the homepage. Only facts visible in each screenshot are recorded here.
import iniTopLearner from "../assets/images/testimonials/ini-abasi-top-learner.webp";
import iniReply from "../assets/images/testimonials/ini-abasi-reply.webp";
import iniDashboard from "../assets/images/testimonials/ini-abasi-dashboard.webp";
import chiwuikem from "../assets/images/testimonials/chiwuikem-akalonu-certificate.webp";
import nwabueze from "../assets/images/testimonials/nwabueze-prosper-certified.webp";
import stanley from "../assets/images/testimonials/stanley-eke-business-analytics.webp";
import onwuka from "../assets/images/testimonials/onwuka-chinecherem-scholarship.webp";
import funmilayo from "../assets/images/testimonials/funmilayo-ogunmola-excel.webp";
import adelaja from "../assets/images/testimonials/adelaja-temiloluwa-zapier.webp";
import godspower from "../assets/images/testimonials/godspower-uzoamaka-ai-automation.webp";
import mbateren from "../assets/images/testimonials/mbateren-eric-automation.webp";
import kris from "../assets/images/testimonials/kris-eyo-recommends.webp";

// category: "data" | "ai" | "community"; every image is exported at 900px wide
// tag: short label shown as a pill on the card (English proper-noun style labels)
export const alumniStories = [
  {
    id: "ini-top-learner",
    name: "Ini Abasi",
    headline: "Data Analyst | BI Developer",
    category: "data",
    tag: "Top 3 Learner of the Month",
    image: iniTopLearner,
    height: 1398, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Ini Abasi on being recognised as a Top 3 Learner of the Month at E1X Academy",
    home: true,
  },
  {
    id: "chiwuikem-certificate",
    name: "Chiwuikem Akalonu",
    headline: "First Class Computer Engineer | Data Analyst",
    category: "data",
    tag: "Foundational Data Analytics",
    image: chiwuikem,
    height: 1356, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Chiwuikem Akalonu sharing a Foundational Data Analytics certificate from E1X Academy",
    home: true,
  },
  {
    id: "onwuka-scholarship",
    name: "Onwuka Chinecherem",
    headline: "Content Writer | Brand Storytelling",
    category: "data",
    tag: "Scholarship Cohort",
    image: onwuka,
    height: 1280, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Onwuka Chinecherem on being selected for the E1X Academy Data Analytics cohort",
    home: true,
  },
  {
    id: "adelaja-zapier",
    name: "Adelaja Temiloluwa",
    headline: "DevOps/Cloud Engineer",
    category: "ai",
    tag: "AI Automation",
    image: adelaja,
    height: 1165, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Adelaja Temiloluwa about a lead-to-close automation built with Zapier at E1X Academy",
    home: true,
  },
  {
    id: "stanley-business",
    name: "Stanley Eke",
    headline: "Regional Sales Manager | Business Development",
    category: "data",
    tag: "Data Analytics for Business Professionals",
    image: stanley,
    height: 1406, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Stanley Eke on completing Data Analytics for Business Professionals with E1X Academy",
    home: true,
  },
  {
    id: "godspower-ai",
    name: "Godspower Uzoamaka",
    headline: "Finance & Customer Service Professional",
    category: "ai",
    tag: "AI Automation",
    image: godspower,
    height: 1431, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Godspower Uzoamaka on learning AI automation with n8n at E1X Academy",
    home: true,
  },
  {
    id: "nwabueze-certified",
    name: "Nwabueze Prosper",
    headline: "Data Analyst | Virtual Assistant",
    category: "data",
    tag: "Certified Data Analyst",
    image: nwabueze,
    height: 1154, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Nwabueze Prosper announcing a Foundational Data Analytics certificate from E1X Academy",
  },
  {
    id: "funmilayo-excel",
    name: "Funmilayo Ogunmola",
    headline: "Biochemistry graduate | STEM Educator",
    category: "data",
    tag: "Building in Public",
    image: funmilayo,
    height: 1419, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Funmilayo Ogunmola on learning VLOOKUP, XLOOKUP and INDEX/MATCH with E1X Academy",
  },
  {
    id: "ini-dashboard",
    name: "Ini Abasi",
    headline: "Data Analyst | BI Developer",
    category: "data",
    tag: "Learner Project",
    image: iniDashboard,
    height: 1113, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "E1X Academy LinkedIn post featuring a regional sales analysis dashboard built by Ini Abasi",
  },
  {
    id: "mbateren-automation",
    name: "Mbateren N Eric",
    headline: "Scoa Heritage System",
    category: "ai",
    tag: "Learner Project",
    image: mbateren,
    height: 974, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Mbateren N Eric on a mini project turning manual sales into automation as an E1X Academy student",
  },
  {
    id: "ini-reply",
    name: "Ini Abasi",
    headline: "Data Analyst | BI Developer",
    category: "data",
    tag: "On the Program",
    image: iniReply,
    height: 301, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn comment by Ini Abasi saying E1X Academy's structured program has been pivotal to their growth",
  },
  {
    id: "kris-recommends",
    name: "Kris Eyo",
    headline: "Connecting Pan-African Talent to Global Scholarships",
    category: "community",
    tag: "Community Voice",
    image: kris,
    height: 1409, // intrinsic px at width 900 — lets the browser reserve space before the image loads
    alt: "LinkedIn post by Kris Eyo recommending E1X Academy as a place to start or transition into tech",
  },
];

export const homeStories = alumniStories.filter((s) => s.home);

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
